/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from './util/prop_types';
import { NotificationSelectors } from './stores/notification_selectors';
import Header from  './shared_components/header';
import NotFound from './shared_components/not_found';
//import Loader from './shared_components/loader';
//import { SuccessModal } from './shared_components/success_modal';
//import { ErrorModal } from './shared_components/error_modal';

const mapStateToProps = (state) => {
  return {
    notFound: NotificationSelectors.isNotFound(state)
  }
}

function removeElement(element) {
  if (element && element.parentNode) {
    element.parentNode.removeChild(element);
  }
}

class App extends React.Component {
  propTypes: {
    notFound: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    children: PropTypes.any
  }

  componentDidMount() {
    removeElement(document.getElementById('initial-loading'));
    removeElement(document.getElementById('error-loading'));
  }

  render(): ?React.Element<any> {
    return (
      <div data-test='root' className='root'>
        <Header />
        {this.props.notFound ? <NotFound /> : this.props.children}
        {/*<SuccessModal />
        <ErrorModal />*/}
        {/*<Loader />*/}
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps)(App));
